/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  CheckBusinessHoursRequestDto,
  CreateBusinessHoursDto,
  DataEnvelopeOfBusinessHoursDto,
  DataEnvelopeOfCheckBusinessHoursResponseDto,
  DataEnvelopeOfObject,
  DataPaginationEnvelopeOfBusinessHoursDto,
  ErrorEnvelope,
  GetBusinessHoursParams,
  UpdateBusinessHoursDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * Cria novo horário comercial para uma loja
 */
export const createBusinessHours = (
  createBusinessHoursDto: CreateBusinessHoursDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfBusinessHoursDto>(
    {
      url: `/v1/business-hours`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBusinessHoursDto,
      signal,
    },
    options,
  )
}

export const getCreateBusinessHoursMutationKey = () => ['createBusinessHours'] as const

export const getCreateBusinessHoursMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBusinessHours>>,
    TError,
    CreateBusinessHoursMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBusinessHours>>,
  TError,
  CreateBusinessHoursMutationVariables,
  TContext
> => {
  const mutationKey = getCreateBusinessHoursMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBusinessHours>>,
    CreateBusinessHoursMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createBusinessHours(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateBusinessHoursMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBusinessHours>>
>
export type CreateBusinessHoursMutationBody = CreateBusinessHoursDto
export type CreateBusinessHoursMutationError = ErrorEnvelope
export type CreateBusinessHoursMutationVariables = { data: CreateBusinessHoursDto }

export const useCreateBusinessHours = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBusinessHours>>,
      TError,
      CreateBusinessHoursMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBusinessHours>>,
  TError,
  CreateBusinessHoursMutationVariables,
  TContext
> => {
  return useMutation(getCreateBusinessHoursMutationOptions(options), queryClient)
}
/**
 * Lista horários comerciais por loja
 */
export const getBusinessHours = (
  params?: GetBusinessHoursParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfBusinessHoursDto>(
    { url: `/v1/business-hours`, method: 'GET', params, signal },
    options,
  )
}

export const getGetBusinessHoursQueryKey = (params?: GetBusinessHoursParams) => {
  return [`/v1/business-hours`, ...(params ? [params] : [])] as const
}

export const getGetBusinessHoursQueryOptions = <
  TData = Awaited<ReturnType<typeof getBusinessHours>>,
  TError = unknown,
>(
  params?: GetBusinessHoursParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessHours>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBusinessHoursQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessHours>>> = ({ signal }) =>
    getBusinessHours(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBusinessHours>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessHoursQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessHours>>>
export type GetBusinessHoursQueryError = unknown

export function useGetBusinessHours<
  TData = Awaited<ReturnType<typeof getBusinessHours>>,
  TError = unknown,
>(
  params: undefined | GetBusinessHoursParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessHours>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessHours>>,
          TError,
          Awaited<ReturnType<typeof getBusinessHours>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessHours<
  TData = Awaited<ReturnType<typeof getBusinessHours>>,
  TError = unknown,
>(
  params?: GetBusinessHoursParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessHours>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessHours>>,
          TError,
          Awaited<ReturnType<typeof getBusinessHours>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessHours<
  TData = Awaited<ReturnType<typeof getBusinessHours>>,
  TError = unknown,
>(
  params?: GetBusinessHoursParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessHours>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBusinessHours<
  TData = Awaited<ReturnType<typeof getBusinessHours>>,
  TError = unknown,
>(
  params?: GetBusinessHoursParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessHours>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBusinessHoursQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Obtém horário comercial específico
 */
export const getBusinessHoursByUuid = (
  uuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfBusinessHoursDto>(
    { url: `/v1/business-hours/${uuid}`, method: 'GET', signal },
    options,
  )
}

export const getGetBusinessHoursByUuidQueryKey = (uuid: string) => {
  return [`/v1/business-hours/${uuid}`] as const
}

export const getGetBusinessHoursByUuidQueryOptions = <
  TData = Awaited<ReturnType<typeof getBusinessHoursByUuid>>,
  TError = ErrorEnvelope,
>(
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBusinessHoursByUuid>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetBusinessHoursByUuidQueryKey(uuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessHoursByUuid>>> = ({ signal }) =>
    getBusinessHoursByUuid(uuid, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: uuid !== null && uuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBusinessHoursByUuid>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetBusinessHoursByUuidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBusinessHoursByUuid>>
>
export type GetBusinessHoursByUuidQueryError = ErrorEnvelope

export function useGetBusinessHoursByUuid<
  TData = Awaited<ReturnType<typeof getBusinessHoursByUuid>>,
  TError = ErrorEnvelope,
>(
  uuid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBusinessHoursByUuid>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessHoursByUuid>>,
          TError,
          Awaited<ReturnType<typeof getBusinessHoursByUuid>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessHoursByUuid<
  TData = Awaited<ReturnType<typeof getBusinessHoursByUuid>>,
  TError = ErrorEnvelope,
>(
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBusinessHoursByUuid>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessHoursByUuid>>,
          TError,
          Awaited<ReturnType<typeof getBusinessHoursByUuid>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessHoursByUuid<
  TData = Awaited<ReturnType<typeof getBusinessHoursByUuid>>,
  TError = ErrorEnvelope,
>(
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBusinessHoursByUuid>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBusinessHoursByUuid<
  TData = Awaited<ReturnType<typeof getBusinessHoursByUuid>>,
  TError = ErrorEnvelope,
>(
  uuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBusinessHoursByUuid>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBusinessHoursByUuidQueryOptions(uuid, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Atualiza horário comercial
 */
export const updateBusinessHours = (
  uuid: string,
  updateBusinessHoursDto: UpdateBusinessHoursDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfBusinessHoursDto>(
    {
      url: `/v1/business-hours/${uuid}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateBusinessHoursDto,
      signal,
    },
    options,
  )
}

export const getUpdateBusinessHoursMutationKey = () => ['updateBusinessHours'] as const

export const getUpdateBusinessHoursMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBusinessHours>>,
    TError,
    UpdateBusinessHoursMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBusinessHours>>,
  TError,
  UpdateBusinessHoursMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateBusinessHoursMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBusinessHours>>,
    UpdateBusinessHoursMutationVariables
  > = (props) => {
    const { uuid, data } = props ?? {}

    return updateBusinessHours(uuid, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateBusinessHoursMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBusinessHours>>
>
export type UpdateBusinessHoursMutationBody = UpdateBusinessHoursDto
export type UpdateBusinessHoursMutationError = ErrorEnvelope
export type UpdateBusinessHoursMutationVariables = { uuid: string; data: UpdateBusinessHoursDto }

export const useUpdateBusinessHours = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBusinessHours>>,
      TError,
      UpdateBusinessHoursMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBusinessHours>>,
  TError,
  UpdateBusinessHoursMutationVariables,
  TContext
> => {
  return useMutation(getUpdateBusinessHoursMutationOptions(options), queryClient)
}
/**
 * Deleta horário comercial
 */
export const deleteBusinessHours = (
  uuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/business-hours/${uuid}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteBusinessHoursMutationKey = () => ['deleteBusinessHours'] as const

export const getDeleteBusinessHoursMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBusinessHours>>,
    TError,
    DeleteBusinessHoursMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBusinessHours>>,
  TError,
  DeleteBusinessHoursMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteBusinessHoursMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBusinessHours>>,
    DeleteBusinessHoursMutationVariables
  > = (props) => {
    const { uuid } = props ?? {}

    return deleteBusinessHours(uuid, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteBusinessHoursMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBusinessHours>>
>

export type DeleteBusinessHoursMutationError = ErrorEnvelope
export type DeleteBusinessHoursMutationVariables = { uuid: string }

export const useDeleteBusinessHours = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBusinessHours>>,
      TError,
      DeleteBusinessHoursMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBusinessHours>>,
  TError,
  DeleteBusinessHoursMutationVariables,
  TContext
> => {
  return useMutation(getDeleteBusinessHoursMutationOptions(options), queryClient)
}
/**
 * Verifica se a hora atual está dentro do horário comercial da loja
 */
export const checkIfWithinBusinessHours = (
  storeUuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCheckBusinessHoursResponseDto>(
    { url: `/v1/business-hours/check/${storeUuid}`, method: 'GET', signal },
    options,
  )
}

export const getCheckIfWithinBusinessHoursQueryKey = (storeUuid: string) => {
  return [`/v1/business-hours/check/${storeUuid}`] as const
}

export const getCheckIfWithinBusinessHoursQueryOptions = <
  TData = Awaited<ReturnType<typeof checkIfWithinBusinessHours>>,
  TError = ErrorEnvelope,
>(
  storeUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkIfWithinBusinessHours>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getCheckIfWithinBusinessHoursQueryKey(storeUuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkIfWithinBusinessHours>>> = ({
    signal,
  }) => checkIfWithinBusinessHours(storeUuid, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: storeUuid !== null && storeUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof checkIfWithinBusinessHours>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type CheckIfWithinBusinessHoursQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkIfWithinBusinessHours>>
>
export type CheckIfWithinBusinessHoursQueryError = ErrorEnvelope

export function useCheckIfWithinBusinessHours<
  TData = Awaited<ReturnType<typeof checkIfWithinBusinessHours>>,
  TError = ErrorEnvelope,
>(
  storeUuid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkIfWithinBusinessHours>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfWithinBusinessHours>>,
          TError,
          Awaited<ReturnType<typeof checkIfWithinBusinessHours>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfWithinBusinessHours<
  TData = Awaited<ReturnType<typeof checkIfWithinBusinessHours>>,
  TError = ErrorEnvelope,
>(
  storeUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkIfWithinBusinessHours>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkIfWithinBusinessHours>>,
          TError,
          Awaited<ReturnType<typeof checkIfWithinBusinessHours>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckIfWithinBusinessHours<
  TData = Awaited<ReturnType<typeof checkIfWithinBusinessHours>>,
  TError = ErrorEnvelope,
>(
  storeUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkIfWithinBusinessHours>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCheckIfWithinBusinessHours<
  TData = Awaited<ReturnType<typeof checkIfWithinBusinessHours>>,
  TError = ErrorEnvelope,
>(
  storeUuid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkIfWithinBusinessHours>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCheckIfWithinBusinessHoursQueryOptions(storeUuid, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * Verifica se uma hora específica está dentro do horário comercial da loja
 */
export const checkIfWithinBusinessHoursAt = (
  storeUuid: string,
  checkBusinessHoursRequestDto: CheckBusinessHoursRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCheckBusinessHoursResponseDto>(
    {
      url: `/v1/business-hours/check-at/${storeUuid}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checkBusinessHoursRequestDto,
      signal,
    },
    options,
  )
}

export const getCheckIfWithinBusinessHoursAtMutationKey = () =>
  ['checkIfWithinBusinessHoursAt'] as const

export const getCheckIfWithinBusinessHoursAtMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkIfWithinBusinessHoursAt>>,
    TError,
    CheckIfWithinBusinessHoursAtMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkIfWithinBusinessHoursAt>>,
  TError,
  CheckIfWithinBusinessHoursAtMutationVariables,
  TContext
> => {
  const mutationKey = getCheckIfWithinBusinessHoursAtMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkIfWithinBusinessHoursAt>>,
    CheckIfWithinBusinessHoursAtMutationVariables
  > = (props) => {
    const { storeUuid, data } = props ?? {}

    return checkIfWithinBusinessHoursAt(storeUuid, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CheckIfWithinBusinessHoursAtMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkIfWithinBusinessHoursAt>>
>
export type CheckIfWithinBusinessHoursAtMutationBody = CheckBusinessHoursRequestDto
export type CheckIfWithinBusinessHoursAtMutationError = ErrorEnvelope
export type CheckIfWithinBusinessHoursAtMutationVariables = {
  storeUuid: string
  data: CheckBusinessHoursRequestDto
}

export const useCheckIfWithinBusinessHoursAt = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkIfWithinBusinessHoursAt>>,
      TError,
      CheckIfWithinBusinessHoursAtMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkIfWithinBusinessHoursAt>>,
  TError,
  CheckIfWithinBusinessHoursAtMutationVariables,
  TContext
> => {
  return useMutation(getCheckIfWithinBusinessHoursAtMutationOptions(options), queryClient)
}
